import { Directive, HostListener, inject } from '@angular/core';
import { PrivacyConsentService } from './privacy-consent.service';

@Directive({
  selector: '[edPrivacyConsentDialog]',
})
export class PrivacyConsentDialogDirective {
  service = inject(PrivacyConsentService);

  @HostListener('click')
  onClick() {
    this.service.openPrivacyConsent();
  }
}
